export default __webpack_public_path__ + "static/media/stlouis_.41203342.jpg";